export default "__VITE_ASSET__ef1fce3c__"